import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { useQuery } from '@tanstack/react-query';
import { Card, CardContent } from '@/components/ui/card';
import { InternalTeamList } from './InternalTeamList';
import { ProspectPipeline } from './ProspectPipeline';
import { InternalTaskBoard } from './InternalTaskBoard';
import { Users, Target, TrendingUp, BarChart3 } from 'lucide-react';

export function SalesManagerDashboard() {
  const { data: stats } = useQuery({
    queryKey: ['sales-manager-stats'],
    queryFn: async () => {
      const [teams, prospects, tasks] = await Promise.all([
        supabase.from('internal_teams').select('*', { count: 'exact', head: true }).eq('department_id', (await supabase.from('internal_departments').select('id').eq('name', 'Sales').single()).data?.id || ''),
        supabase.from('sales_prospects').select('status', { count: 'exact' }),
        supabase.from('internal_tasks').select('*', { count: 'exact', head: true }),
      ]);
      const prospectData = prospects.data || [];
      return {
        totalTeams: teams.count || 0,
        totalProspects: prospectData.length,
        converted: prospectData.filter((p: any) => p.status === 'converted').length,
        totalTasks: tasks.count || 0,
      };
    },
  });

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Sales Manager Dashboard</h2>
        <p className="text-muted-foreground">Oversee all sales operations</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card><CardContent className="p-4 flex items-center gap-3"><Users className="h-8 w-8 text-blue-500" /><div><p className="text-2xl font-bold">{stats?.totalTeams || 0}</p><p className="text-xs text-muted-foreground">Teams</p></div></CardContent></Card>
        <Card><CardContent className="p-4 flex items-center gap-3"><Target className="h-8 w-8 text-orange-500" /><div><p className="text-2xl font-bold">{stats?.totalProspects || 0}</p><p className="text-xs text-muted-foreground">Total Prospects</p></div></CardContent></Card>
        <Card><CardContent className="p-4 flex items-center gap-3"><TrendingUp className="h-8 w-8 text-green-500" /><div><p className="text-2xl font-bold">{stats?.converted || 0}</p><p className="text-xs text-muted-foreground">Converted</p></div></CardContent></Card>
        <Card><CardContent className="p-4 flex items-center gap-3"><BarChart3 className="h-8 w-8 text-primary" /><div><p className="text-2xl font-bold">{stats?.totalTasks || 0}</p><p className="text-xs text-muted-foreground">Total Tasks</p></div></CardContent></Card>
      </div>

      <InternalTeamList departmentName="Sales" canManage />
      <ProspectPipeline viewAll />
    </div>
  );
}
